import React from 'react';
import { CellTypes } from '@received/pricing-model';
import { PricingModelTableComponent } from './PricingModelTable';
import type { PricingModelTableProps } from './PricingModelTable';
import { requiredColumnsEnum } from './PricingModelTable.utils';

// Embedded (V2) contract table: thin fork over PricingModelTableComponent that only changes which
// columns render (full `pricingModelTable` still drives all calculations). Hides ITEM, Quantity,
// Amount, and a lone usage-aggregator column — each surfaced elsewhere in the contract UI.
export const PricingModelTableComponentV2 = (props: PricingModelTableProps) => {
	const columns = props.pricingModelTable?.columns || [];

	// Drop ITEM (row's "Item" cell), Quantity (both the hidden `quantity` FORMULA and the `usage` COUNT
	// input FIXED templates use — driven by the row's "Quantity" field), and Amount (shown as "Total").
	// The Pay-as-you-go `usage` aggregator column is a different type, handled just below.
	let gridColumns = columns.filter(
		(col) =>
			col.type !== CellTypes.ITEM_REFERENCE &&
			col.id !== requiredColumnsEnum.quantity &&
			!(col.id === 'usage' && col.type === CellTypes.COUNT) &&
			col.id !== requiredColumnsEnum.amount,
	);

	// Hide a lone usage column; ContractContentV2 renders a "Usage product" selector for it above the table.
	const usageColumns = columns.filter((col) => col.type === CellTypes.USAGE_AGGREGATOR_REFERENCE);
	if (usageColumns.length === 1) {
		gridColumns = gridColumns.filter((col) => col.id !== usageColumns[0].id);
	}

	return <PricingModelTableComponent {...props} renderColumns={gridColumns} />;
};
